import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import classNames from 'classnames';
const MenuItems = React.forwardRef((_a, ref) => {
    var { pullRight, className, children } = _a, remainingProps = __rest(_a, ["pullRight", "className", "children"]);
    const dropdownMenuClasses = classNames('dropdown-menu', pullRight && 'pull-right', className);
    return (_jsx("ul", Object.assign({}, remainingProps, { className: dropdownMenuClasses, ref: ref, role: 'menu' }, { children: children })));
});
export default MenuItems;
